<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item, additionalData)"
      v-for="item in items"
      :key="item.header || item.title"
      :item="item"
    />
    <div class="mt-2">
      <b-skeleton
        v-if="!items.length"
        v-for="num in [1,2,3,4,5,6,7,8,9]"
        :key="num"
        width="25px"
        height="25px"
        class="mx-auto mb-2"
        type="avatar">
      </b-skeleton>
    </div>
  </ul>

</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup
  },
  computed: {
    ...mapGetters({
      userData: 'getUserData'
    }),
    additionalData() {
      return {
        shipperCountryCode: this.userData?.shipper?.country?.code,
        organizationCountryCode: this.userData?.organization?.country?.code,
        organizationId: this.userData?.organization?.id
      }
    }
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent
    }
  }
}
</script>
